module.exports = __webpack_public_path__ + "img/icn-spec__active--gray.af7c7db8.svg";